<template>
    <layout>
        <main class="identify-page">
            <section class="header">
                <div class="container">
                    <h2>Upload Fastener Calculations and Submittals</h2>
                    <p>
                        Upload a PDF file to be included as an attachment in your report
                    </p>
                </div>
            </section>

            <section>
                <div class="container">
                    <fieldset>
                        <p v-if="error" class="error" v-text="error"></p>
                        <p v-if="success" class="success" v-text="success"></p>

                        <div class="text">
                            <label for="title">Title</label>
                            <input v-model="record.title" type="text" id="title">
                        </div>

                        <form enctype="multipart/form-data">
                            <div class="file">
                                <label for="filename">Upload a PDF File</label>
                                <input type="file" id="file-upload" name="fileU_upload" accept="application/pdf" @change="setTitle">
                            </div>
                        </form>
                    </fieldset>
                </div>
            </section>

            <section>
                <div class="confirm">
                    <div>
                        <a href="/submittal-manager" class="button back simple alternate">Projects</a>
                    </div>
                    <div>
                        <save-button v-on:clicked="saveThenReturn"></save-button>
                        </button>
                    </div>
                </div>
            </section>
        </main>
        <aside class="primary">
        </aside>
    </layout>
</template>

<script>
    import Vue from 'vue';

    import Layout from './layout';

    import Errors from './shared/errors';
    import Actions from './shared/actions';

    import axios from 'axios';

    export default {
        components: {
            Layout,
            Actions,
            Errors,
        },

        data: function() {
            return {
                error: '',
                success: '',
                type: 'submittalFileUpload',
                editing: this.id === null,
                record: {
                    id: '',
                    designId: this.$route.params.designId,
                    filename: '',
                    url: '',
                    title: ''
                },
                uploadToken: '',
            };
        },

        computed: {
        },

        watch: {
            record: {
                handler: function() {
                    this.$emit('sync-file-upload', { uid: this.uid, ...this.record });
                },
                deep: true
            },
        },

        props: [
            'uid',
        ],

        methods: {
            upload() {
                var record = this.record;
                var token  = this.uploadToken;

                return new Promise(function(resolve, reject) {
                    // Post the file.
                    var formData = new FormData();
                    var fileInput = document.querySelector('#file-upload');

                    formData.append("file", fileInput.files[0]);
                    formData.append("title", record.title);
                    formData.append("token", token);
                    formData.append("design_id", record.designId);

                    axios.post('/actions/seismic-submittal/file-upload', formData, {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        var data = response.data;

                        if (data.error) {
                            reject({ 'message' : data.error });
                        } else {
                            resolve(data);
                        }

                    }).catch((error) => {
                        reject(error);
                    });
                });
            },

            setTitle() {
                if (this.record.title) {
                    return;
                }

                var fileInput = document.querySelector('#file-upload');

                if (fileInput.files[0] && fileInput.files[0].name) {
                    var tempName = fileInput.files[0].name;

                    tempName = tempName.replace(/\.pdf/gi, '');

                    this.record.title = tempName.replace(/_/gi, ' ');
                }
            },

            saveThenReturn() {
                this.error = '';
                this.success = '';

                if (!this.validate) {
                    return;
                }

                this.upload()
                .then((data) => {
                    this.id       = data.id;
                    this.filename = data.filename;
                    this.url      = data.url;

                    this.success = data.filename + ' has been successfully uploaded';
                })
                .then(() => {
                    // rework so it reloads the correct list of pdfs instead of reloading
                    window.location.href = '/submittal-manager/seismic/v2/' + this.record.designId;
                }).catch((error) => {
                    // Error
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        // onsole.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);

                        this.error = error.response.data;
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        // console.log(error.request);
                        this.error = error.request;
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        // console.log('Error', error.message);
                        this.error = error.message;
                    }

                });
            },

            validate() {
                this.error = 'Please choose a file';
                return document.querySelector('#file-upload').files[0] ? true : false;
            },
        },
        mounted() {
            // Assign data element to a var to expand it's scope
            var data = this;

            axios.get('/actions/seismic-submittal/file-upload/get-upload-token')
                .then(function (response) {
                    data.uploadToken = response.data;
                })
                .catch(function (error) {
                    //console.log(error);
                });
        },
    };
</script>
